const SLACK_WEBHOOK_URL = 'https://hooks.slack.com/services/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'

export const noticeToSlack = async (channel: string, text: string, username: string = 'slack bot'): Promise<void> => {
  try {
    const obj = {
      channel,
      username,
      text,
      icon_emoji: ':slack:'
    }
    const method = 'POST'
    const body = JSON.stringify(obj)
    const headers = {
      Accept: 'application/json'
    }
    await fetch(SLACK_WEBHOOK_URL, { method, headers, body })
  } catch (error) {
    // エラーを握りつぶす
  }
}

export const noticeQuizStartToSlack = async (
  channel: string,
  memberId: number,
  projectId: number,
  planStatus: string,
  resetOrNot: string,
  projectTitle: string,
  eventTitle: string,
  username: string = 'slack bot'
): Promise<void> => {
  try {
    const messageBlock = {
      channel: '',
      username: '',
      icon_emoji: ':slack:',
      blocks: [
        {
          type: 'section',
          text: {
            type: 'mrkdwn',
            text: 'クイズが始まりました！'
          }
        },
        {
          type: 'divider'
        },
        {
          type: 'section',
          fields: [
            {
              type: 'mrkdwn',
              // tslint:disable-next-line: max-line-length
              text: `*・member_id:* ${memberId} \n *・project_id:* ${projectId} \n *・購入状況:* ${planStatus} \n *・リセット:* ${resetOrNot} \n *・プロジェクト名:* ${projectTitle} \n *・タイトル名:* ${eventTitle}`
            }
          ]
        },
        {
          type: 'divider'
        }
      ]
    }
    messageBlock.channel = channel
    messageBlock.username = username
    const method = 'POST'
    const body = JSON.stringify(messageBlock)
    const headers = {
      Accept: 'application/json'
    }
    await fetch(SLACK_WEBHOOK_URL, { method, headers, body })
  } catch (error) {
    // エラーを握りつぶす
  }
}

export const notifyPurchaseToSlack = async (
  channel: string,
  memberId: number,
  planName: string,
  eventDate: string | undefined,
  referer: string | undefined,
  username: string = 'slack bot'
): Promise<void> => {
  try {
    const messageBlock = {
      channel: '',
      username: '',
      icon_emoji: ':slack:',
      blocks: [
        {
          type: 'section',
          text: {
            type: 'mrkdwn',
            text: '購入されました！'
          }
        },
        {
          type: 'divider'
        },
        {
          type: 'section',
          fields: [
            {
              type: 'mrkdwn',
              // tslint:disable-next-line: max-line-length
              text: `*・member_id:* ${memberId} \n *・購入プラン:* ${planName} \n *・ご利用予定日:* ${eventDate ||
                '未定'} \n *・知ったきっかけ:* ${referer || '未回答'}`
            }
          ]
        },
        {
          type: 'divider'
        }
      ]
    }

    messageBlock.channel = channel
    messageBlock.username = username
    const method = 'POST'
    const body = JSON.stringify(messageBlock)
    const headers = {
      Accept: 'application/json'
    }
    await fetch(SLACK_WEBHOOK_URL, { method, headers, body })
  } catch (error) {
    // エラーを握りつぶす
  }
}
